import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "@/lib/content";

const TRIO = [
  { tag: "Welcome", note: "Arrival, concierge, guest care", tone: "text-oxblood-soft" },
  { tag: "Table", note: "Chefs, dining, adventure catering", tone: "text-gold" },
  { tag: "Restore", note: "Wellness, recovery, quiet", tone: "text-forest-soft" },
];

export default function About() {
  return (
    <section id="about" className="relative bg-bg py-28 md:py-40" data-testid="about">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-start">
          <div className="lg:col-span-7">
            <Reveal>
              <Overline>Brand Proposition</Overline>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif font-light tracking-tight text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
                The property provides the setting.{" "}
                <em className="italic text-metallic-gold">We help create the stay.</em>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 space-y-6 max-w-xl font-sans text-base md:text-lg text-ink/65 leading-relaxed">
                <p>
                  Lodge &amp; Retreat Partners works with owners, operators, property
                  managers and travel professionals to deliver complete private
                  hospitality across premium lodges, retreats, villas and private
                  residences.
                </p>
                <p>
                  Through one trusted point of contact, we coordinate arrival
                  preparation, concierge, private dining, adventure catering, snow
                  and mountain sports catering, wellness and recovery.
                </p>
              </div>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-px bg-white/10 border border-white/10">
              {TRIO.map((p, i) => (
                <Reveal key={p.tag} delay={0.1 + i * 0.08}>
                  <div className="bg-bg p-6 md:p-8 h-full" data-testid={`about-pillar-${p.tag.toLowerCase()}`}>
                    <span className={`font-sans text-[0.65rem] tracking-[0.3em] uppercase ${p.tone}`}>
                      0{i + 1} &nbsp;·&nbsp; {p.tag}
                    </span>
                    <p className="mt-5 font-sans text-sm text-ash leading-relaxed">
                      {p.note}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 lg:pt-16">
            <Reveal delay={0.2}>
              <div className="relative overflow-hidden aspect-[3/4]">
                <motion.img
                  src={IMAGES.interior}
                  alt="Alpine lodge interior with restorative wellness setting"
                  className="h-full w-full object-cover img-cinematic"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
                />
                <div className="absolute inset-0 border border-white/10 pointer-events-none" />
              </div>
              <div className="mt-6">
                <p className="font-serif italic text-xl md:text-2xl text-ink/80 leading-snug">
                  One trusted hospitality partner coordinating every essential element
                  of an extraordinary stay.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
